import { useMutation } from '@tanstack/react-query';
import { openAccountEarn } from '../requests';
import type { OpenAccountResponseDto } from '../types';

interface UseOpenAccountEarnOptions {
  onSuccess?: (data: OpenAccountResponseDto) => void;
}

const useOpenAccountEarn = (options?: UseOpenAccountEarnOptions) => {
  const mutation = useMutation({
    mutationFn: openAccountEarn,
    onSuccess: options?.onSuccess,
  });

  return {
    openAccount: mutation.mutateAsync,
    isOpenAccountPending: mutation.isPending,
    isOpenAccountSuccess: mutation.isSuccess,
    isOpenAccountError: mutation.isError,
    openAccountData: mutation.data,
    openAccountError: mutation.error,
  };
};

export { useOpenAccountEarn };
